import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/userdetails/userWiseDurationReport/v1/?employeeUUID=11efb78d-dd6e-a612-9d30-22f17ecb52c5&startDate=29/12/2024&endDate=29/12/2024&isPagination=1&pageNo=1&perPageRec=2
export const getUserWiseDurationReportAPIURL = BaseURl + "userdetails/userWiseDurationReport/v1/";

//https://testcockpit.p2k.in/api/userdetails/getActiveUsersList/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&isPagination=1&pageNo=1&perPageRec=2
export const getActiveUserListAPIURL = BaseURl + "userdetails/getActiveUsersList/v1/";
